import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { close as clearTools, getTools } from '@reducers/clampingTools';
import { connect } from 'react-redux';
import { updateHeaderConfig } from '@reducers/details';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { useRoute } from '@react-navigation/native';
import { productionBatchStatistics } from '@reducers/statistics';
import { loadSingleBatch } from '@reducers/batch';
import { SingleBatchOrBatchList } from '@v2/pages/common/components/SingleBatchOrBatchList/SingleBatchOrBatchList';
import { LoadSingleBatch } from '@interfaces/methods';
import { parseRouteParamAsNumber } from '@helpers';

interface NCFileDetailsBatchProps {
  loadSingleBatch: LoadSingleBatch;
}

const NCFileDetailsBatchComponent: FC<NCFileDetailsBatchProps> = ({
  getProductionBatchByNCFile,
  getNCFileById,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
  loadSingleBatch,
}) => {
  const title = useTitle();
  const route = useRoute();

  useNCFileDetails({
    clearTools,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    getNCFileById,
    operationsSearch,
    getNCFileByName,
    loadSingleBatch,
  });

  const ncFileId = parseRouteParamAsNumber(route.params?.ncFileId);

  return (
    <DetailsPageWrapper title={title.batch}>
      <SingleBatchOrBatchList ncFileId={ncFileId} withoutImage />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsBatch = connect(null, {
  getNCFileById,
  getProductionBatchByNCFile,
  getTools,
  clearTools,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
  productionBatchStatistics,
  loadSingleBatch,
})(NCFileDetailsBatchComponent);

export { NCFileDetailsBatch };
